export default __webpack_public_path__ + "static/media/People_00.54150e99.png";